<ng-container *ngIf="!currentTask">
  <div class="title">
    <h1 class="product-heading-bold">Tasks</h1>
  </div>
  <span class="data-heading">You would find here all the task and stages that are been saved from {{'scope' | lang }} by roles.
  <br>When you are scoping you will be able to use them anytime.</span>

   <div class="flex flex-row justify-end items-center gap-2 h-12">
    <!--TODO: Add stages tab in phase 2-->
    <!--<scope-ui-tabs
      class='flex-1'
      [fontSize]="'14px'"
      (onSelect)="currentTab = $event">
      <scope-ui-tab
        tabTitle="Tasks"
        class="scope-tab white-background"
        [active]="currentTab === 'Tasks'" >
      </scope-ui-tab>
      <scope-ui-tab
        tabTitle="Stages"
        class="scope-tab white-background"
        [active]="currentTab === 'Stages'">
      </scope-ui-tab>
    </scope-ui-tabs>-->
    <button
      class="text-link ml-4 mr-4"
      aria-label="Show descriptions"
      (click)="showDescriptions = !showDescriptions"
      onclick="this.blur()">
      <mat-icon class="material-symbols-rounded icon-small orange">{{showDescriptions ? 'visibility_off' : 'visibility'}}</mat-icon>
      {{showDescriptions ? 'Hide Descriptions' : 'Show Descriptions'}}
    </button>
    <mat-divider vertical />
    <scope-ui-input
      [icon]="'search'"
      [inputLabel]="'Search'"
      [cancelIcon]="'cancel'"
      (onEnter)="onSearchKeyPressed($event)"
      (onCancel)="onSearchKeyPressed('')"
      [inputClass]="'search-field'" />
    <mat-divider vertical />
    <button class="action-button" (click)="addTask()" mat-button>
      <mat-icon class="material-symbols-rounded mb-1">add</mat-icon>Add Task
    </button>
    <button
      class="scope-actions-button"
      (click)="$event.stopPropagation()"
      [matMenuTriggerFor]="optionsMenu">
      <mat-icon class="material-symbols-rounded">more_vert</mat-icon>
    </button>
    <mat-menu
      #optionsMenu="matMenu"
      backdropClass="scope-options-menu">
      <button
        (click)="upload()"
        mat-menu-item
        class="scope-option">
        <mat-icon class="material-symbols-rounded orange">upload_file</mat-icon>
        <span>Upload Tasks</span>
      </button>
      <button
        (click)="export()"
        mat-menu-item
        class="scope-option">
        <mat-icon class="material-symbols-rounded orange">file_download</mat-icon>
        <span>Export Tasks</span>
      </button>
    </mat-menu>
  </div>
  <mat-divider></mat-divider>
  <scope-ui-table
    class="block mt-1"
    *ngIf="currentTab === 'Tasks'"
    [loading]="loading$ | async"
    [tableClass]="'overview-table'"
    [loggedInUser]='loggedInUser'
    [data]="mappedTasksDataSource$ | async"
    [displayedColumns]="taskColumns$ | async"
    [addToggleListColumn]="true"
    [totalCount]="tableData?.totalCount"
    [page]="tableData?.page"
    [showToggleMenu]="true"
    [menuOptions]="menuOptions"
    [expandable]="false"
    [showDescription]="true"
    [showHideDescriptionOnly]="true"
    [displayAllDescriptions]="showDescriptions"
    [rowGaps]="true"
    [condensed]="true"
    (pageChange)="onChangePage($event)"
    (onToggle)="onTogglePreference($event)"
    (onSelect)="onSelectTask($event)"
    (onSort)="onSort($event)">
  </scope-ui-table>
</ng-container>

<ng-container *ngIf="currentTask">
  <button class="text-link ml-4 mr-4 flex" (click)="backToTasks()">
    <mat-icon class="material-symbols-rounded icon-small orange">arrow_back_ios</mat-icon>
    Back
  </button>
  <div class="task-header">
    <div class="task-title-actions">
      <div class="title flex items-center">
        <mat-icon class="material-symbols-rounded icon-small">task_alt</mat-icon>
        <h1 class="product-heading-bold ml-2" *ngIf="!editName">{{currentTask.name}}</h1>
        <scope-ui-input *ngIf="editName" class="ml-2"
                        [autofocus]='true'
                        (onInputBlurChange)="renameTask($event); editName = false"
                        [initialValue]="currentTask.name"
                        [isDisabled]="!loggedInUser.hasPrivilege('LIBRARY_DELIVERABLE__EDIT')" />
        <button
          class="scope-actions-button"
          (click)="$event.stopPropagation()"
          [matMenuTriggerFor]="optionsMenu">
          <mat-icon class="material-symbols-rounded">more_vert</mat-icon>
        </button>
        <mat-menu
          #optionsMenu="matMenu"
          backdropClass="scope-options-menu">
          <button
            (click)="editName = true"
            mat-menu-item
            class="scope-option">
            <mat-icon class="material-symbols-rounded orange">edit</mat-icon>
            <span>Rename</span>
          </button>
          <button
            (click)="deleteTask(this.currentTask)"
            mat-menu-item
            class="scope-option">
            <mat-icon class="material-symbols-rounded orange">delete</mat-icon>
            <span>Delete</span>
          </button>
        </mat-menu>
      </div>
      <div class="actions">
        <div class="flex flex-row justify-end items-center gap-2 h-12">
          <scope-ui-input
            [inputPlaceholder]="''"
            [icon]="'search'"
            [inputLabel]="'Search'"
            [cancelIcon]="'cancel'"
            (onEnter)="onRoleSearch($event)"
            (onCancel)="onRoleSearch('')"
            [inputClass]="'search-field'" />
          <mat-divider vertical />
          <button class="action-button" (click)="addRoles(this.currentTask)" mat-button>
            <mat-icon class="material-symbols-rounded mb-1">add</mat-icon>Add Roles
          </button>
          <mat-divider vertical *ngIf="outOfSync" />
          <button *ngIf="outOfSync" class="action-button" (click)="updateTask()" mat-button>
            Save updates
          </button>

        </div>
      </div>
    </div>
    <div class="details">
      <div>
      <span class="detail-field">
        <span class="title">FTE:</span>
        <span class="data">{{ loggedInUser.company.fteValue }}</span>
      </span>
          <span class="detail-field">
        <span class="title">Total hours:</span>
        <span class="data">{{ currentTask.getFormattedHours() }}</span>
      </span>
      <span class="detail-field">
        <span class="title">Rate Card:</span>
        <span class="data"> {{ currentTask.rateCardVersion.name }}</span>
      </span>
          <span class="detail-field">
        <span class="title">Rate Card Version:</span>
        <span class="data"> {{ currentTask.rateCardVersion.version }}</span>
      </span>
          <span class="detail-field">
        <span class="title">Cost Price:</span>
        <span class="data trs">{{currentTask.getTotalCostPrice().amount | currency: currentTask.rateCardVersion.currencyCode}}</span>
      </span>
          <span class="detail-field">
        <span class="title trs">Selling Price:</span>
        <span class="data trs">{{currentTask.getTotalSellingPrice().amount | currency: currentTask.rateCardVersion.currencyCode}}</span>
      </span>
        </div>
    </div>
  </div>
  <mat-divider></mat-divider>

  <scope-by-role-task-table
    [currentUser]="loggedInUser"
    [libraryTask]="currentTask$ | async"
    [tableExpanded]="tableExpanded"
    [searchText]="searchRoleText"
    (outOfSyncChange)="outOfSync = $event">
  </scope-by-role-task-table>
    <button class="text-link mt-2 add-item-button"
            mat-button (click)="addRoles(this.currentTask)">
      <mat-icon class="material-symbols-rounded mb-1">assignment_ind</mat-icon>
      Update Roles
    </button>
</ng-container>
